import DetailContentLayoutTemplate from './DetailContentLayoutTemplate'

export default DetailContentLayoutTemplate
// eslint-disable-next-line import/export
export * from './DetailContentLayoutTemplate'
